/** Ponto de entrada do SPA. */

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { criarClienteDeConsultas } from './api/consultas'
import { criarRoteador } from './rotas/roteador'
import './estilos.css'

// O **mesmo** cliente nos dois lugares: o provider das telas e o contexto do roteador. Dois
// clientes dariam dois caches de sessao, e a guarda decidiria por um enquanto o shell mostra o
// outro.
const clienteDeConsultas = criarClienteDeConsultas()
const roteador = criarRoteador(clienteDeConsultas)

const raiz = document.getElementById('raiz')
if (!raiz) {
  throw new Error('Elemento #raiz nao encontrado no index.html')
}

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteDeConsultas}>
      <RouterProvider router={roteador} />
    </QueryClientProvider>
  </StrictMode>,
)
